module.exports = __webpack_public_path__ + "img/icon-generic-exit.65016388.svg";